import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { ArrowRightOutlined, ShoppingOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Button from '@components/base/Button';
import Price from '@components/base/Price';

export default function MobileCartBarFish() {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = useLocation();
  const isVisible = isMobile && lineCount > 0 && pathname !== '/cart' && pathname !== '/checkout';

  useEffect(() => {
    document.documentElement.classList.toggle('fish-mobile-cart-bar-active', isVisible);
    return () => {
      document.documentElement.classList.remove('fish-mobile-cart-bar-active');
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fish-mobile-cart-bar"
      style={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        right: 12,
        zIndex: 9,
        boxSizing: 'border-box',
        maxWidth: 'calc(100vw - 1.5rem)',
        background: 'var(--fish-app-primary, var(--color-primary, #0647a6))',
        color: 'var(--background-text-color, #fff)',
        borderRadius: 'var(--radius-card)',
        padding: '0.625rem 0.75rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          minWidth: 0,
          flex: '1 1 auto',
        }}
      >
        <ShoppingOutlined style={{ fontSize: 18, flexShrink: 0 }} />
        <div
          style={{
            fontSize: 13,
            lineHeight: 1.2,
            minWidth: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          <strong>{lineCount}</strong> {lineCount === 1 ? 'item' : 'items'}
          <div style={{ opacity: 0.9 }}>
            <Price amount={cart?.grandTotal ?? cart?.subtotal ?? 0} />
          </div>
        </div>
      </div>
      <Link to="/cart" style={{ flexShrink: 0 }}>
        <Button shape="round" size="small">
          Basket <ArrowRightOutlined />
        </Button>
      </Link>
    </div>
  );
}
